const isBrowser = typeof window !== 'undefined';

export const storage = {
  get(key, fallback = null) {
    if (!isBrowser) return fallback;

    try {
      const value = window.localStorage.getItem(key);
      if (value === null) return fallback;
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  },

  set(key, value) {
    if (!isBrowser) return;

    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Failed to write to localStorage:', error);
    }
  },

  remove(key) {
    if (!isBrowser) return;

    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error('Failed to remove from localStorage:', error);
    }
  },

  clear() {
    if (!isBrowser) return;

    try {
      window.localStorage.clear();
    } catch (error) {
      console.error('Failed to clear localStorage:', error);
    }
  },
};

export const session = {
  get(key, fallback = null) {
    if (!isBrowser) return fallback;

    try {
      const value = window.sessionStorage.getItem(key);
      if (value === null) return fallback;
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  },

  set(key, value) {
    if (!isBrowser) return;

    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Failed to write to sessionStorage:', error);
    }
  },

  remove(key) {
    if (!isBrowser) return;

    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      console.error('Failed to remove from sessionStorage:', error);
    }
  },

  clear() {
    if (!isBrowser) return;

    try {
      window.sessionStorage.clear();
    } catch (error) {
      console.error('Failed to clear sessionStorage:', error);
    }
  },
};
